import { BACKEND } from "../variables.js";
import axios from "axios";

const GET_SYSTEM_CONFIG = BACKEND + "/systemConfig/get";
const UPDATE_SYSTEM_CONFIG = BACKEND + "/systemConfig/update";
const GET_EMAIL_TEMPLATES = BACKEND + "/systemConfig/emailTemplates";
const SEND_TEST_EMAIL = BACKEND + "/systemConfig/sendTestEmail";
const GET_TEMPLATE_HOUSES = BACKEND + "/systemConfig/templateHouses";
const GET_EMAIL_TEMPLATE = BACKEND + "/systemConfig/getEmailTemplate";
const SAVE_EMAIL_TEMPLATE = BACKEND + "/systemConfig/saveEmailTemplate";
const GET_SMS_TEMPLATES = BACKEND + "/systemConfig/smsTemplates";
const SAVE_SMS_TEMPLATE = BACKEND + "/systemConfig/saveSmsTemplate";
const SEND_TEST_SMS = BACKEND + "/systemConfig/sendTestSms";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_SYSTEM_CONFIG"](state, payload) {
      return axios({
        method: "POST",
        url: GET_SYSTEM_CONFIG,
        data: {},
      });
    },
    ["UPDATE_SYSTEM_CONFIG"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_SYSTEM_CONFIG,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["GET_EMAIL_TEMPLATES"](state, payload) {
      return axios({
        method: "POST",
        url: GET_EMAIL_TEMPLATES,
        data: {},
        headers: payload && payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["SEND_TEST_EMAIL"](state, payload) {
      return axios({
        method: "POST",
        url: SEND_TEST_EMAIL,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["GET_TEMPLATE_HOUSES"](state, payload) {
      return axios({
        method: "POST",
        url: GET_TEMPLATE_HOUSES,
        data: {},
        headers: payload && payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["GET_EMAIL_TEMPLATE"](state, payload) {
      return axios({
        method: "POST",
        url: GET_EMAIL_TEMPLATE,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["SAVE_EMAIL_TEMPLATE"](state, payload) {
      return axios({
        method: "POST",
        url: SAVE_EMAIL_TEMPLATE,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["GET_SMS_TEMPLATES"](state, payload) {
      return axios({
        method: "POST",
        url: GET_SMS_TEMPLATES,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["SAVE_SMS_TEMPLATE"](state, payload) {
      return axios({
        method: "POST",
        url: SAVE_SMS_TEMPLATE,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
    ["SEND_TEST_SMS"](state, payload) {
      return axios({
        method: "POST",
        url: SEND_TEST_SMS,
        data: payload.data,
        headers: payload.token ? { Authorization: payload.token } : {},
      });
    },
  },
};
